import { Box, Button, Stack, Typography } from "@compass/core";
import { SubmitButton } from "components";

import { ReportSelection, ReportType, ScreenType } from "./StudentReportPage";

export const StudentReportPageHeader = (props: {
  handle: string;
  reportTypes: ReportSelection[];
  selectedReportType: ReportType | undefined;
  screen: ScreenType;
  setScreen: (screen: ScreenType) => void;
  generateReport: () => void;
}) => {
  const reportType = props.reportTypes.find((x) => x.name === props.selectedReportType);

  return (
    <Stack direction="row" justifyContent="space-between">
      <Typography variant="inherit">{props.handle}</Typography>

      <Stack direction="row" alignItems="center" spacing="sm">
        {props.screen === "report" && (
          <Button variant="outlined" onClick={(e) => props.setScreen("config")}>
            Back
          </Button>
        )}

        {props.screen === "config" && (
          <SubmitButton
            onClick={props.generateReport}
            label={reportType?.generateTypes.includes("direct-pdf") ? "Open Report in PDF" : "Generate Report"}
          />
        )}
      </Stack>
    </Stack>
  );
};
